export const extractWhiteboardTemplateKeyFromPath = (href: string) => {
	const normalizedHref = href.replace(/[\r\n\t]+/g, '').trim();
	const match = normalizedHref.match(/(?:^|\/)whiteboard-template\/([^/?#]+)/);
	return match?.[1] || null;
};
